<div class="edit-lot-container" ngStyle.lt-lg="width: 95%">
    <div style=" font-size: 14px" *ngIf="projectId">
        <span routerLink="/projects" style="outline: none; cursor: pointer">Projects</span> / <span
            routerLink="/projects/{{projectId}}" style="outline: none; cursor: pointer">{{projectName}}</span> / Edit
        Lot / {{lot ? lot.lotNumber : ''}}
    </div>
    <div style="display: flex; justify-content: space-between; align-items: center">
        <h4 style="">EDIT LOT</h4>
        <div style="display: flex; align-items: center">
            <button mat-button class="delete-lot delete_button" (click)="openDeleteLotDialog()">
                DELETE LOT
            </button>
        </div>
    </div>
    <div style="box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12); padding: 40px; background: #000">
        <div style="border: 1px solid #e6e5e5; padding: 20px; margin-bottom: 20px; border-radius: 6px">
            <h4 style="margin-top: 0; margin-bottom: 20px; ">Lot Image</h4>
            <img *ngIf="lot && lot.lotImage"
                src="{{SERVER_URL}}images/{{projectCode}}/images/lots/{{lot.lotImage.fileName}}"
                style="width: 120px; height: 120px">
            <form [formGroup]="logoImageForm" style="display: flex; flex-direction: column">
                <input accept="image/*" type="file" formControlName="logo" multiple="" (change)="onLogoChange($event)">
                <p *ngIf="isLogoTooLarge === true" style="color: #f44336; font-size: 14px">Logo image size cannot exceed
                    1.5MB.</p>
                <p *ngIf="hasLogo === true" style="color: #f44336; font-size: 14px">Please delete the current logo
                    before uploading a new one.</p>

                <button mat-button [disabled]="this.logo.length === 0 || isLogoUploading === true"
                    [ngClass]="{'deactivated': this.logo.length === 0 || isLogoUploading === true, 'activated': this.logo.length !== 0 && !this.isLogoUploading}"
                    style="background: #000; color: #dedede; width: fit-content; margin-top: 20px;border: 1px solid #dedede;"
                    (click)="uploadProjectLogo()">
                    <img src="./assets/images/upload.svg"
                        style="width: 16px; height: 16px; margin-bottom: 2px; margin-right: 5px">
                    {{isLogoUploading ? 'Uploading...' : 'Upload'}}
                </button>
            </form>
        </div>
        <div style="border: 1px solid #e6e5e5; padding: 20px; margin-bottom: 20px; border-radius: 6px">
            <h4 style="margin-top: 0; margin-bottom: 0; ">Package</h4>
            <p *ngIf="lot && (!lot.packageProjects || lot.packageProjects.length === 0)"
                style="color: #9b9b9b;  font-size: 14px">No package has been linked to this lot.</p>
            <p *ngIf="lot && lot.packageProjects.length > 0" style="color: #9b9b9b;  font-size: 14px">
                {{lot.packageProjects.length}} package{{lot.packageProjects.length > 1 ? 's' :
                ''}} ha{{lot.packageProjects.length > 1 ? 've' : 's'}} been linked to this lot.</p>

            <button mat-button style="background: #3C50E0; color: #fff" (click)="openLinkPackage(lot)">Choose
                package(s)</button>
        </div>
        <form [formGroup]="form">
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Lot number</mat-label>
                    <input matInput formControlName="lotNumber" required>
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Lot Status</mat-label>
                    <select matNativeControl formControlName="status" required>
                        <option [value]=6>Settle</option>
                        <option [value]=5>Unconditional</option>
                        <option [value]=4>Exchange conditional</option>
                        <option [value]=3>Reserved</option>
                        <option [value]=2>EOI</option>
                        <option [value]=1>Available</option>
                        <option [value]=0>Unavailable</option>
                    </select>
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Lot price</mat-label>
                    <input matInput formControlName="price" type=number required>
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Lot size</mat-label>
                    <input matInput formControlName="lotSize" required>
                    <span matSuffix>m²</span>
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: space-between">
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Width</mat-label>
                    <input matInput formControlName="width" required>
                    <span matSuffix>m</span>
                </mat-form-field>
                <mat-form-field appearance="outline" style="width: 45%">
                    <mat-label>Length</mat-label>
                    <input matInput formControlName="length" required>
                    <span matSuffix>m</span>
                </mat-form-field>
            </div>
            <!--            <mat-form-field appearance="outline" style="width: 45%">-->
            <!--                <mat-label>Stage</mat-label>-->
            <!--                <input matInput formControlName="stage" required>-->
            <!--            </mat-form-field>-->
            <mat-radio-group formControlName="parkFront" style="margin-bottom: 20px" required>
                <div style="display: flex; margin-bottom: 20px">
                    <h4 [ngClass]="{'parkFront-required': form.get('parkFront').invalid && isSubmitted}"
                        style="margin-top: 0; margin-bottom: 0">
                        Park Front *</h4>
                    <div style="margin-left: 50px">
                        <mat-radio-button [value]=1 style="margin-right: 40px">
                            Yes
                        </mat-radio-button>
                        <mat-radio-button [value]=0>
                            No
                        </mat-radio-button>
                    </div>
                </div>

            </mat-radio-group>
            <mat-radio-group formControlName="lakeFront" style="margin-bottom: 20px" required>
                <div style="display: flex;  margin-bottom: 20px">
                    <h4 [ngClass]="{'lakeFront-required': form.get('lakeFront').invalid && isSubmitted}"
                        style="margin-top: 0; margin-bottom: 0">
                        Lake Front *</h4>
                    <div style="margin-left: 50px">
                        <mat-radio-button [value]=1 style="margin-right: 40px">
                            Yes
                        </mat-radio-button>
                        <mat-radio-button [value]=0>
                            No
                        </mat-radio-button>
                    </div>

                </div>
            </mat-radio-group>
            <mat-radio-group formControlName="cornerBlock" style="margin-bottom: 20px" required>
                <div style="display: flex; margin-bottom: 20px">
                    <h4 [ngClass]="{'cornerBlock-required': form.get('cornerBlock').invalid && isSubmitted}"
                        style="margin-top: 0; margin-bottom: 0">
                        Corner Block *</h4>
                    <div style="margin-left: 50px">
                        <mat-radio-button [value]=1 style="margin-right: 40px">
                            Yes
                        </mat-radio-button>
                        <mat-radio-button [value]=0>
                            No
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <h4>Property Promotion Tags</h4>
            <div fxLayout="row wrap">
                <mat-checkbox *ngFor="let tag of propertyPromotionTags" [checked]="isCheckBoxSelected(tag.id)"
                    (change)="select($event, tag.id)" style="width: 33%">
                    {{tag.notes.en}}
                </mat-checkbox>
            </div>
            <div style="display: flex; justify-content: flex-end; margin-top: 20px">
                <button mat-button (click)="updateLot()" class="update_button">Update lot</button>
            </div>
        </form>

    </div>
</div>